import type { PortfolioSubject } from "portfolio/types";

/**
 * Subject resource from API.
 * TODO: Replace with generated type once endpoint is added to OpenAPI.
 */
type SubjectResource = {
  id: number;
  name: string;
};

export const subjectFromDto = (dto: SubjectResource): PortfolioSubject => ({
  id: dto.id,
  name: dto.name,
});
